import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ChevronRight, Shovel } from "lucide-react";
import { PHASE_MAP, phaseBadge } from "@/lib/phases";
import { SitePlaceholder } from "@/components/SitePlaceholder";

export const PyramidListItem = ({ p }) => {
  const hasDeepDive = !!p.research;
  const ph = PHASE_MAP[p.phase] || PHASE_MAP.pyramids;
  const src = p.gallery?.[0];
  const [broken, setBroken] = useState(false);
  const showImg = src && !broken;

  return (
    <Link
      to={`/pyramid/${p.slug}`}
      data-testid={`pyramid-row-${p.slug}`}
      className="group flex items-center gap-3 sm:gap-5 px-3 py-2 hover:bg-secondary/50 transition-colors"
    >
      <div className="relative h-10 w-14 shrink-0 overflow-hidden bg-secondary border border-border">
        {showImg ? (
          <img
            src={src}
            alt={p.name}
            loading="lazy"
            onError={() => setBroken(true)}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <SitePlaceholder phase={p.phase} compact className="h-full w-full" />
        )}
        <span className="absolute bottom-0 left-0 h-0.5 w-full" style={{ background: ph.color }} />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="font-serif text-base sm:text-lg font-bold text-foreground truncate group-hover:text-accent transition-colors">
            {p.name}
          </h3>
          {hasDeepDive && <Shovel data-testid={`deep-dive-icon-${p.slug}`} className="h-3 w-3 text-accent shrink-0" title="Deep dive available" />}
        </div>
        <p className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground truncate">
          <MapPin className="h-2.5 w-2.5 shrink-0" /> {p.region || p.country}
        </p>
      </div>

      <div className="hidden md:flex items-center gap-5 font-mono text-[11px] uppercase tracking-wider text-muted-foreground shrink-0">
        <span className="w-32 truncate" style={{ color: ph.color }}>{phaseBadge(p.phase)}</span>
        <span className="w-28 truncate">{p.country}</span>
        <span className="w-16 text-right">{p.height_m ? `${p.height_m} m` : "—"}</span>
        <span className="w-28 text-right">{p.estimated_age ? p.estimated_age.split("(")[0].trim() : "Undated"}</span>
      </div>

      <ChevronRight className="h-4 w-4 text-muted-foreground group-hover:text-accent group-hover:translate-x-1 transition-all shrink-0" />
    </Link>
  );
};
